import React, { useEffect } from "react";
import { Modal, ModalBody } from "react-bootstrap";

interface LoadingModalProps {
  modalLoadingOpen: boolean;
  closeLoadingModal: () => void;
}

const LoadingModal = ({
  modalLoadingOpen,
  closeLoadingModal,
}: LoadingModalProps) => {
  useEffect(() => {}, [modalLoadingOpen]);

  return (
    <div>
      <Modal
        backdrop="static"
        show={modalLoadingOpen}
        onHide={closeLoadingModal}
      >
        <ModalBody>
          <div className="d-flex justify-content-center">
            <div className="spinner-border">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          <br />
          Ihre Daten werden geladen. Dies kann einen Moment dauern.
        </ModalBody>
      </Modal>
    </div>
  );
};

export default LoadingModal;
